import { AiFillPlusCircle } from "react-icons/ai";
import { BsArrowLeftShort } from "react-icons/bs";
import { Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { FaEye, FaMinus } from "react-icons/fa";

import {
  Box,
  Button,
  Loader,
  Modal,
  Table,
  Text,
  TextField,
} from "../../components";
import { Colors, Fonts, Images, Utils } from "../../config";
import { ServiceAction } from "../../store/actions";
import "./style.css";

function ServiceDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { subServices } = useSelector((state) => state.service);

  // second case is to handle the issue of coming back from subservices detail page to this.
  // on that case it is not finding any location.state.record due to which getting null so that is why
  // we use this solution.
  const state = location?.state?.record || location?.state;
  console.log(state)

  // assuming i add some third layer of data in sub survices detail page now when i came back here to get
  // the updated data i used this approach to call an api.
  useEffect(() => {
    if (location?.state?.id) {
      setIsSubServicesDirty(true);
    }
  }, [])

  const [showModal, setShowModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editService, setEditService] = useState(false);
  const [isSubServicesDirty, setIsSubServicesDirty] = useState(false);
  const [selectedService, setSelectedService] = useState({});
  const [selectedSubServices, setSelectedSubServices] = useState([""]);
  const [error, setError] = useState({
    id: "",
    name: "",
    subService: { name: "", index: 0 },
    image: "",
  });
  const [service, setService] = useState({
    serviceName: "",
    subServices: [{}],
    serviceImage: null,
  });

  // for managing second layer mutations task
  const [secondLayerService, setSecondLayerService] = useState({
    subServices: [{
      id: null,
      name: ""
    }],
  })

  console.log(secondLayerService)

  // third layer states.
  const [showThirdLayerModal, setShowThirdLayerModal] = useState(false);
  const [thirdLayerEditService, setThirdLayerEditService] = useState(false);
  const [thirdLayerSelectedService, setThirdLayerSelectedService] = useState({});
  const [thirdLayerDeleteSubServiceIndex, setThirdLayerDeleteServiceIndex] = useState("");
  const [singleServiceModal, setSingleServiceModal] = useState(false);
  const [thirdLayerRecord, setThirdLayerRecord] = useState({})
  const [lengthOfThirdLayerServices, setLengthOfThirdLayerServices] = useState(1);
  const [thirdLayerService, setThirdLayerService] = useState({
    serviceName: "",
    subServices: [""],
    serviceImage: null,
  });

  const [thirdLayerError, setThirdLayerError] = useState({
    id: "",
    name: "",
    subService: [""],
    image: "",
  });

  const handleAddMoreSubservices = () => {
    // let err = [...error.subService];
    // var bool = false;
    // selectedSubServices.forEach((subService, index) => {
    //   if (subService.name.trim() !== "") {
    //     err[index] = "";
    //   } else {
    //     bool = true;
    //     err[index] = "Please enter sub service name";
    //   }
    // });
    // setError({ ...error, subService: err });
    // if (!bool) {
    //   setSelectedSubServices([
    //     ...selectedSubServices,
    //     {
    //       id: service.subServices.length + Math.floor(Math.random() * 1000),
    //       name: "",
    //       new: true,
    //       noOfUsers: null,
    //       index: null,
    //       isEdit: true,
    //     },
    //   ]);
    // }
    let updatedSubServices = [...secondLayerService.subServices];
    updatedSubServices.push({ id: null, name: "" })
    setSecondLayerService((prev) => ({ ...prev, subServices: updatedSubServices }))
  };

  // second layer remove item handler
  const secondRemoveHandler = (index) => {
    let updatedSubServices = [...secondLayerService.subServices];
    updatedSubServices.splice(index, 1)
    setSecondLayerService((prev) => ({ ...prev, subServices: updatedSubServices }))
  }

  const handleDeleteSubservice = (id) => {

    if (service?.subServices?.length == 1) {
      Utils.showSnackBar({
        message: "There must be at least one sub service for a service",
        severity: "error",
      });
      // console.log(service?.subServices)
      // setDeleteModal(false);
      // setShowModal(false)
    }

    else {
      dispatch(
        ServiceAction.deleteService(id, () => {
          setDeleteModal(false);
          setSelectedService({});
          setIsSubServicesDirty(true);
          setSelectedSubServices((prev) =>
            prev.filter((subServ) => subServ.id !== selectedService.id)
          );
        })
      )
    };
  };

  const handleAddSubservice = () => {
    let secondLayerClone = [...secondLayerService?.subServices]
    let secondLayerValidationIndex = secondLayerClone.findIndex(item => item?.name == '')
    if (secondLayerValidationIndex == 0 || secondLayerValidationIndex !== -1) {
      setError({
        ...error,
        subService: { index: secondLayerValidationIndex, name: "Sub Service is required" }
      })
    }
    else {
      // let err = [...error.subService];
      // var bool = false;
      // selectedSubServices.forEach((subService, index) => {
      //   if (subService.name.trim() !== "") {
      //     err[index] = "";
      //   } else {
      //     bool = true;
      //     err[index] = "Please enter sub service name";
      //   }
      // });
      // if (bool == true) {
      //   setError({ ...error, name: "", subService: err });
      //   return;
      // } else {
      //   setError({ ...error, subService: err });
      //   let subServices = [];
      //   selectedSubServices?.forEach((subService, index) => {
      //     if (!subService?.new) {
      //       subServices.push({
      //         id: subService?.id,
      //         name: subService?.name
      //       })
      //     }
      //     else {
      //       subServices.push({
      //         id: null,
      //         name: subService?.name
      //       })
      //     }
      //   });
      const myPayload = {
        parentId: state?.id,
        subServices: secondLayerService?.subServices
      }
      dispatch(
        ServiceAction.updateSubServices(myPayload, () => {
          setShowModal(false);
          setEditService(false);
          setSecondLayerService({
            subServices: [
              {
                id: null,
                name: ""
              }
            ]
          })
          setError({
            id: "",
            name: "",
            subService: { name: "", index: 0 },
            image: "",
          })
          setIsSubServicesDirty(true);
        })
      );
    }

  };



  useEffect(() => {
    if (state) {
      setService({
        serviceName: state.name,
        subServices: state.subServices.map((subService, index) => {
          return {
            ...subService,
            new: false,
          };
        }),
        serviceImage: state.imageUrl,
      });
    }
  }, []);

  useEffect(() => {
    if (isSubServicesDirty) {
      dispatch(
        ServiceAction.getAllSubServices(state.id, (res) => {
          setService({ ...service, subServices: res.data.subServices });
          setIsSubServicesDirty(false);
        })
      );
    } else {
      return
    }
  }, [isSubServicesDirty]);


  // const thirdLayerSubServiceHandler = (record) => {
  //   setThirdLayerRecord(record)
  //   dispatch(
  //     ServiceAction.getAllSubServices(record?.id, (res) => {
  //       setThirdLayerService({
  //         serviceName: record?.name,
  //         subServices: res?.data?.subServices?.length > 0 ? res?.data?.subServices?.map((subService, index) => {
  //           return {
  //             ...subService,
  //             new: false
  //           }
  //         }) : []
  //       })
  //       setLengthOfThirdLayerServices(res?.data?.subServices?.length)
  //       setShowThirdLayerModal(true)
  //       setIsSubServicesDirty(false);
  //     })
  //   );
  // }



  // const handleCreateService = () => {
  //   // if (thirdLayerService.serviceName === "") {
  //   //   setThirdLayerError({ ...error, name: "Service name is required" });
  //   // }
  //   // if (
  //   //   thirdLayerService.serviceName.trim() === "" ||
  //   //   !(
  //   //     Utils.alphaNumericRegex.test(thirdLayerService.serviceName) &&
  //   //     isNaN(thirdLayerService.serviceName)
  //   //   )
  //   // ) {
  //   //   setThirdLayerError({ ...thirdLayerError, name: "Enter a valid service name" });
  //   // }
  //   // if (thirdLayerService.serviceName.length > 30) {
  //   //   setThirdLayerError({
  //   //     ...thirdLayerError,
  //   //     name: "Service name cannot be greater than 30 characters",
  //   //   });
  //   // }
  //   // else {
  //   let err = [...thirdLayerError.subService];
  //   var bool = false;
  //   thirdLayerService?.subServices.forEach((subService, index) => {
  //     const subServiceName = subService.name ? subService.name : subService; // Handle both object and string cases
  //     if (subServiceName) {
  //       if (subServiceName?.trim() !== "") {
  //         err[index] = "";
  //       }
  //       else {
  //         bool = true;
  //         err[index] = "Please enter sub service name";
  //       }
  //     }
  //     else {
  //       if (subServiceName?.trim() !== "") {
  //         err[index] = "";
  //       }
  //       else {
  //         bool = true;
  //         err[index] = "Please enter sub service name";
  //       }
  //     }
  //   });
  //   if (bool == true) {
  //     setThirdLayerError({ ...thirdLayerError, name: "", subService: err });
  //     return;
  //   }
  //   // if (thirdLayerService.serviceImage === null) {
  //   //   setError({
  //   //     ...error,
  //   //     name: "",
  //   //     subService: "",
  //   //     image: "Service image is required",
  //   //   });
  //   //   return;
  //   // } 
  //   else {
  //     let parentId = thirdLayerRecord && thirdLayerRecord?.id;
  //     let subServices = thirdLayerService?.subServices?.map((item) => {
  //       if (item?.id) {
  //         return {
  //           id: item?.id,
  //           name: item?.name
  //         }
  //       }
  //       else {
  //         return {
  //           id: null,
  //           name: item?.name
  //         }
  //       }
  //     })

  //     // editService
  //     //   ? dispatch(
  //     //     ServiceAction.updateService(service.id, formData, () => {
  //     //       setShowThirdLayerModal(false);
  //     //       setThirdLayerService({
  //     //         serviceName: "",
  //     //         subServices: [""],
  //     //         serviceImage: null,
  //     //       });
  //     //       dispatch(ServiceAction.getAllServices(state));
  //     //     })
  //     //   )
  //     // : 
  //     const myPayload = {
  //       parentId,
  //       subServices
  //     }
  //     dispatch(
  //       ServiceAction.updateSubServices(myPayload, () => {
  //         setShowThirdLayerModal(false);
  //         setThirdLayerService({
  //           serviceName: "",
  //           subServices: [""],
  //           serviceImage: null,
  //         });
  //         setThirdLayerError({
  //           name: "",
  //           subService: "",
  //           image: "",
  //         });
  //         setIsSubServicesDirty(true);
  //       })
  //     );
  //   }
  // };

  // const handleThirdLayerAddMoreSubservices = () => {
  //   let err = [...thirdLayerError.subService];
  //   var bool = false;
  //   thirdLayerService?.subServices?.forEach((subService, index) => {
  //     const subServiceName = subService.name ? subService.name : subService; // Handle both object and string cases
  //     if (subServiceName) {
  //       if (subServiceName?.trim() !== "") {
  //         err[index] = "";
  //       } else {
  //         bool = true;
  //         err[index] = "Please enter sub service name";
  //       }
  //     } else {
  //       if (subServiceName?.trim() !== "") {
  //         err[index] = "";
  //       } else {
  //         bool = true;
  //         err[index] = "Please enter sub service name";
  //       }
  //     }
  //   });
  //   setThirdLayerError({ ...thirdLayerError, subService: err });
  //   if (bool == false) {
  //     setThirdLayerService({
  //       ...thirdLayerService,
  //       subServices: [...thirdLayerService.subServices, ""],
  //     });
  //   }
  // };

  const handleThirdLayerDeleteSubservice = (id) => {
    if (lengthOfThirdLayerServices == 1) {
      Utils.showSnackBar({
        message: "There must be at least one sub service for a service",
        severity: "error",
      });
      return
    }
    else if (thirdLayerService.subServices.length > 1) {
      dispatch(
        ServiceAction.deleteService(id, () => {
          setThirdLayerSelectedService({});
          // dispatch(ServiceAction.getAllServices(state));
          setIsSubServicesDirty(true)
          setShowThirdLayerModal(false);
          setSingleServiceModal(false);
        })
      );
      return;
    }
    Utils.showSnackBar({
      message: "There must be at least one sub service for a service",
      severity: "error",
    });
    setSingleServiceModal(false);
  };

  const thirdLayerViewHandler = (record) => {
    let mergeState = {
      record: record,
      previousState: state
    }
    navigate('/service-management/sub-services/details', { state: mergeState })
  }

  return (
    <>
      <Box>
        <Row justify="space-between">
          <Col className="row-flex-start">
            <BsArrowLeftShort
              onClick={() => navigate("/service-management")}
              className="service-details-back-btn"
            />
            <Text.Heading
              fontSize={24}
              fontFamily={Fonts["Poppins-SemiBold"]}
              color={Colors.Black}
              fontWeight={600}
              text={service.serviceName}
            />
          </Col>
          <Col>
            <Button.Basic
              onClick={() => {
                setShowModal(true);
                // setSelectedSubServices([...service.subServices]);
              }}
              text={"Add Sub Service"}
              startIcon={<AiFillPlusCircle color="white" />}
              className="sub-service-add-btn"
            />
          </Col>
        </Row>
        <Row justify="space-between" className="mt-20">
          {isSubServicesDirty ? (
            <Col span={24} className="row-flex-center mt-20">
              <Loader.Circular />
            </Col>
          ) : (
            <Col span={24}>
              <Table.AntDesignTable
                className="service-details-table"
                columns={[
                  {
                    title: "Sub Service",
                    dataIndex: "name",
                    key: "name",
                    render: (text, record) => {
                      return <span>{text}</span>;
                    },
                  },
                  {
                    title: "No Of Sub Service",
                    dataIndex: "noOfUsers",
                    key: "noOfUsers",
                    render: (text, record) => {
                      return <span>{text === null ? "-" : text}</span>;
                    },
                  },
                  {
                    title: "Action",
                    dataIndex: "subscription",
                    key: "subscription",
                    render: (text, record, outerIndex) => (
                      <span className="flex items-center action-layout">
                        <img
                          src={Images.EditIcon}
                          onClick={() => {
                            // setSelectedSubServices([
                            //   ...service.subServices.map((el) =>
                            //     el.id === record.id
                            //       ? { ...el, isEdit: true }
                            //       : el
                            //   ),
                            // ]);
                            setEditService(true);
                            setSecondLayerService(
                              (prev) => {
                                let updatedSubService = [...secondLayerService.subServices];
                                updatedSubService[0] = { id: record?.id, name: record?.name };
                                return {
                                  ...prev,
                                  subServices: updatedSubService
                                }
                              }
                            )
                          }}
                        />{" "}
                        {service.subServices.length > 1 && (
                          <img
                            onClick={() => {
                              setSelectedService(record);
                              setDeleteModal(true);
                            }}
                            src={Images.DeleteIcon}
                          />
                        )}
                        {
                          <div className="view-service">
                            <FaEye size={25} className="" color="#5596F8" onClick={() => thirdLayerViewHandler(record)} />
                          </div>
                        }
                      </span>
                    ),
                  },
                ]}
                data={service.subServices}
                pagination={true}
                rowKey="key"
                loading={isSubServicesDirty}
              />
            </Col>
          )}
        </Row>
        {/* <Row justify="center" style={{ marginTop: "20px" }}>
          <Col>
            <Pagination
              responsive="true"
              showLessItems="true"
              pageSize={5}
              total={service.subServices.length}
              onChange={() => {}}
            />
          </Col>
        </Row> */}
      </Box>
      {deleteModal && (
        <Modal.ConfirmationModal
          title={""}
          isModalVisible={deleteModal}
          heading={"Are you sure you want to delete sub service?"}
          handleCancel={() => setDeleteModal(false)}
          handleDelete={() => {
            console.log(selectedService, selectedSubServices)
            handleDeleteSubservice(selectedService.id);
          }}
        ></Modal.ConfirmationModal>
      )}

      {/* second layer updated working */}
      {showModal && (
        <Modal.AntDesignModal
          title=""
          isModalVisible={showModal}
          destroyOnClose={true}
          maskClosable={false}
          handleCancel={() => {
            setEditService(false);
            setError({
              id: "",
              name: "",
              subService: { name: "", index: 0 },
              image: "",
            })
            setSecondLayerService((prev) => ({
              ...prev, subServices: [{ id: null, name: '' }]
            }))
            setShowModal(false);
          }}
        >
          <Row justify="center">
            <Col>
              <Text.Heading
                fontSize={24}
                fontFamily={Fonts["Poppins-SemiBold"]}
                color={Colors.Black}
                fontWeight={600}
                text={"Add Sub Service"}
              />
            </Col>
          </Row>
          <Row justify="center" className="mt-20">
            <Col span={24}>
              <TextField.CustomInput
                label="Service Name: "
                placeholder="Engine Checkup"
                value={service.serviceName}
                disabled={true}
                size="large"
                type="text"
                className="service-input"
                onChange={(e) =>
                  setService({ ...service, serviceName: e.target.value })
                }
              />
            </Col>
          </Row>
          {/* {selectedSubServices.map((subService, index) => {
            return (
              <Row key={index} justify="center" className="mt-20 mb-10">
                <Col span={24}>
                  <TextField.CustomInput
                    label={
                      index === 0
                        ? `Sub Service Name`
                        : `Sub Service Name ${index + 1}`
                    }
                    placeholder="Enter Sub Service Name"
                    value={subService.name}
                    disabled={subService?.isEdit ? false : true}
                    size="large"
                    type="text"
                    className="service-input"
                    suffix={
                      (subService?.isEdit && !subService?.new ? false : true) &&
                      selectedSubServices.length > 1 && (
                        <img
                          className="cursor"
                          onClick={() => {
                            if (subService.new) {
                              setSelectedSubServices((prev) =>
                                prev.filter(
                                  (subServ) => subServ.id !== subService.id
                                )
                              );
                            } else {
                              const deletedSubservice =
                                selectedSubServices.find(
                                  (sub) => sub.id === subService.id
                                );
                              setSelectedService(deletedSubservice);
                              setDeleteModal(true);
                            }
                          }}
                          src={Images.DeleteSubServiceIcon}
                          width={20}
                        />
                      )
                    }
                    onChange={(e) => {
                      let selectedSubServicesCopy = JSON.parse(
                        JSON.stringify(selectedSubServices)
                      );
                      let newService = {
                        ...selectedSubServices[index],
                        name: e.target.value,
                      };
                      selectedSubServicesCopy[index] = newService;
                      setSelectedSubServices([...selectedSubServicesCopy]);
                    }}
                  />
                  <Text.Heading
                    fontSize={14}
                    fontFamily={Fonts["Poppins-Regular"]}
                    color={"red"}
                    fontWeight={400}
                    text={error.subService[index]}
                    textAlign="center"
                    className="mb-10"
                  />
                </Col>
              </Row>
            );
          })} */}

          {
            secondLayerService?.subServices?.length > 0 &&
            <Row justify="end" className="mt-20">
              {
                secondLayerService?.subServices?.map((service, index) => (
                  <Col span={20} key={index}>
                    <TextField.CustomInput
                      label={<span>{`Sub Service Name: `} <span className="imp-tag">* </span></span>}
                      placeholder="Sub Service Name"
                      value={service?.name}
                      size="large"
                      type="text"
                      className="user-subject-field"
                      name={service.name}
                      onChange={(e) => {
                        const updatedSubServices = [...secondLayerService?.subServices];
                        updatedSubServices[index].name = e?.target?.value;
                        setSecondLayerService((prev) => ({
                          ...prev,
                          subServices: updatedSubServices
                        }))
                      }}
                    />
                    {/*  for error */}
                    <Text.Heading
                      fontSize={14}
                      fontFamily={Fonts["Poppins-Regular"]}
                      color={"red"}
                      fontWeight={400}
                      text={index == error.subService?.index && error?.subService?.name}
                      textAlign="end"
                      className="mt-10"
                    />
                    <span onClick={() => secondRemoveHandler(index)} className="minus-icon"><FaMinus size={23} /></span>
                  </Col>
                ))
              }
            </Row>
          }



          {/* {selectedSubServices.length < 20 && editService === false && ( */}
          <Col className="row-flex-end">
            <Button.Basic
              startIcon={<img src={Images.AddSquareIcon} alt="" />}
              text={"Add More"}
              className="sub-service-add-btn-modal"
              onClick={handleAddMoreSubservices}
            />
          </Col>
          {/* )} */}

          <Row justify="center">
            <Col span={24}>
              <Button.Basic
                text={"Submit"}
                onClick={handleAddSubservice}
                className="sub-service-add-btn mt-20"
              />
            </Col>
          </Row>
        </Modal.AntDesignModal>
      )}

      {editService && (
        <Modal.AntDesignModal
          title=""
          isModalVisible={editService}
          centered={true}
          destroyOnClose={true}
          maskClosable={false}
          handleCancel={() => {
            setError({
              id: "",
              name: "",
              subService: { name: "", index: 0 },
              image: "",
            })
            setSecondLayerService((prev) => ({
              ...prev, subServices: [{ id: null, name: '' }]
            }))
            setEditService(false);
          }}
        >
          <Row justify="center">
            <Col>
              <Text.Heading
                fontSize={24}
                fontFamily={Fonts["Poppins-SemiBold"]}
                color={Colors.Black}
                fontWeight={600}
                text={"Edit Sub Service"}
              />
            </Col>
          </Row>
          <Row justify="end" className="mt-20">
            <Col span={24}>
              <TextField.CustomInput
                label={<span>{`Sub Service Name: `} <span className="imp-tag">* </span></span>}
                placeholder="Enter Sub Service Name"
                value={secondLayerService?.subServices[0]?.name}
                size="large"
                type="text"
                className="user-subject-field"
                onChange={(e) => {
                  let updatedSecondLayerService = secondLayerService?.subServices[0];
                  updatedSecondLayerService.name = e?.target?.value
                  setSecondLayerService((prev) => ({ ...prev, subServices: [updatedSecondLayerService] }))
                }}
              />
              {/*  for error */}
              <Text.Heading
                fontSize={14}
                fontFamily={Fonts["Poppins-Regular"]}
                color={"red"}
                fontWeight={400}
                text={error.subService?.name}
                textAlign="end"
                className="mt-10"
              />
            </Col>
          </Row>
          <Row justify="center">
            <Col span={24}>
              <Button.Basic
                onClick={handleAddSubservice}
                text={"Save Changes"}
                className="service-provider-email-btn"
              />
            </Col>
          </Row>
        </Modal.AntDesignModal>
      )}

      {/* // third layer  */}
      {
        // showThirdLayerModal && (
        //   <Modal.AntDesignModal
        //     title=""
        //     isModalVisible={showThirdLayerModal}
        //     centered={true}
        //     handleCancel={() => {
        //       setThirdLayerService({
        //         serviceName: "",
        //         subServices: [""],
        //         serviceImage: null,
        //       });
        //       setThirdLayerError({
        //         name: "",
        //         subService: "",
        //         image: "",
        //       });
        //       setShowThirdLayerModal(false);
        //     }}
        //   >
        //     <Row justify="center">
        //       <Col>
        //         <Text.Heading
        //           fontSize={24}
        //           fontFamily={Fonts["Poppins-SemiBold"]}
        //           color={Colors.Black}
        //           fontWeight={600}
        //           text={"Add Third Service"}
        //         />
        //       </Col>
        //     </Row>
        //     <Row justify="center" className="mt-20">
        //       <Col span={24}>
        //         <TextField.CustomInput
        //           label="Sub Service Name: "
        //           placeholder="Sub Service Name"
        //           value={thirdLayerRecord?.name && thirdLayerRecord?.name}
        //           size="large"
        //           type="text"
        //           className="user-subject-field"
        //           disabled={true}
        //         />
        //         {/* <Text.Heading
        //           fontSize={14}
        //           fontFamily={Fonts["Poppins-Regular"]}
        //           color={"red"}
        //           fontWeight={400}
        //           text={thirdLayerError.name}
        //           textAlign="center"
        //           className="mt-10"
        //         /> */}
        //       </Col>
        //     </Row>
        //     {
        //       thirdLayerService?.subServices?.map((subService, index) => {
        //         console.log(thirdLayerService?.subServices)
        //         return (
        //           <Row justify="center" className="my-10-20">
        //             <Col span={24}>
        //               <TextField.CustomInput
        //                 label={
        //                   index === 0
        //                     ? `Third Service Name`
        //                     : `Third Service Name ${index + 1}`
        //                 }
        //                 placeholder="MG Motors"
        //                 disabled={subService?.new == false ? true : false}
        //                 suffix={
        //                   <img
        //                     className="cursor"
        //                     onClick={() => {
        //                       if (!subService?.id) {
        //                         setThirdLayerDeleteServiceIndex(index);
        //                         setThirdLayerSelectedService({});
        //                         setSingleServiceModal(true);
        //                       } else {
        //                         setThirdLayerDeleteServiceIndex("");
        //                         setThirdLayerSelectedService(subService);
        //                         setSingleServiceModal(true);
        //                         return
        //                       }

        //                       // if (subService.new) {
        //                       //   setSelectedSubServices((prev) =>
        //                       //     prev.filter(
        //                       //       (subServ) => subServ.id !== subService.id
        //                       //     )
        //                       //   );
        //                       // } else {
        //                       //   const deletedSubservice = selectedSubServices.find(
        //                       //     (sub) => sub.id === subService.id
        //                       //   );
        //                       //   setSelectedService(deletedSubservice);
        //                       //   setDeleteModal(true);
        //                       // }
        //                     }}
        //                     src={Images.DeleteSubServiceIcon}
        //                     width={20}
        //                   />
        //                 }
        //                 value={subService.name}
        //                 size="large"
        //                 type="text"
        //                 className="user-subject-field"
        //                 onChange={(e) =>
        //                   setThirdLayerService({
        //                     ...thirdLayerService,
        //                     subServices: thirdLayerService?.subServices.map((subService, i) =>
        //                       i === index
        //                         ? { ...subService, name: e.target.value } // Only update the name key
        //                         : subService // Keep other objects unchanged
        //                     ),
        //                   })
        //                 }
        //               />
        //               <Text.Heading
        //                 fontSize={14}
        //                 fontFamily={Fonts["Poppins-Regular"]}
        //                 color={"red"}
        //                 fontWeight={400}
        //                 text={thirdLayerError.subService[index]}
        //                 textAlign="center"
        //                 className="mb-10"
        //               />
        //             </Col>
        //           </Row>
        //         );
        //       })}
        //     {thirdLayerService?.subServices?.length < 20 && (
        //       <Col className="row-flex-end">
        //         <Button.Basic
        //           startIcon={<img src={Images.AddSquareIcon} alt="" />}
        //           text={"Add More"}
        //           className="add-more-btn"
        //           onClick={handleThirdLayerAddMoreSubservices}
        //         />
        //       </Col>
        //     )}
        //     <Row justify="center">
        //       <Col span={24}>
        //         <Button.Basic
        //           onClick={handleCreateService}
        //           text={"Submit"}
        //           className="service-provider-email-btn"
        //         />
        //       </Col>
        //     </Row>
        //   </Modal.AntDesignModal>
        // )
      }
      {/* {singleServiceModal && (
        <Modal.ConfirmationModal
          title={""}
          isModalVisible={singleServiceModal}
          heading={"Are you sure you want to delete sub service?"}
          handleCancel={() => setSingleServiceModal(false)}
          handleDelete={() => {
            if (thirdLayerDeleteSubServiceIndex) {
              const deleteSubService = { ...thirdLayerService };
              deleteSubService.subServices.splice(thirdLayerDeleteSubServiceIndex, 1);
              setThirdLayerService(deleteSubService);
              setSingleServiceModal(false);
            }
            else {
              handleThirdLayerDeleteSubservice(thirdLayerSelectedService?.id);
            }

            // setSelectedSubServices((prev) => {
            //   console.log("PREV HMMM", prev);
            //   return prev.filter(
            //     (subServ) => subServ.id !== selectedService.id
            //   );
            // });
          }}
        ></Modal.ConfirmationModal>
      )} */}
    </>
  );
}

export default ServiceDetails;
